const SI_DOMAIN = 'si.com';
const QA_SI_DOMAIN = 'mmsport.minutemediabeta.com'; // TODO: remove after testing

const SI_PROPERTIES = [
  'videogames.si.com',
  'swimsuit.si.com',
  'esi.si.com',
  'highschool.si.com',
  'vault.si.com',
  'lifestyle.si.com',
  'sikids.com',
  'collectibles.si.com',
  'health.si.com',
  'pickleball.si.com',
  'news.si.com',
  'pressroom.si.com',
  'subscriptions.si.com',
  'mmsport.minutemediabeta.com', // TODO: remove this after testing
];

const removeTrailingSlash = (endpoint: string) => {
  return endpoint && endpoint.endsWith('/') ? endpoint.substring(0, endpoint.length - 1) : endpoint;
};

export const isSiProperty = (propertyEndpoint: string) => {
  return propertyEndpoint.includes(SI_DOMAIN) || propertyEndpoint.includes(QA_SI_DOMAIN) || SI_PROPERTIES.includes(removeTrailingSlash(propertyEndpoint));
};
